export default __webpack_public_path__ + "static/media/ionicons.894e9700.ttf";